import { GOLD } from '../../styles/theme';
import { PASSWORD_POLICY } from './passwordPolicy';

/** The password box of the pages reached from an e-mailed link, with its Show / Hide. */
export function PasswordField({
  id,
  value,
  onChange,
  disabled,
  show,
  onToggleShow,
}: {
  readonly id?: string;
  readonly value: string;
  readonly onChange: (v: string) => void;
  readonly disabled: boolean;
  readonly show: boolean;
  readonly onToggleShow: () => void;
}): JSX.Element {
  return (
    <div className="relative">
      <input
        id={id}
        type={show ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-4 pr-10 py-2.5 text-sm rounded-xl outline-none transition-all"
        style={{ background: '#F8F9FC', border: '1.5px solid #E8ECF4', color: '#111827' }}
        placeholder="••••••••••••"
        required
        maxLength={128}
        disabled={disabled}
        onFocus={(e) => (e.currentTarget.style.borderColor = GOLD)}
        onBlur={(e) => (e.currentTarget.style.borderColor = '#E8ECF4')}
      />
      <button
        type="button"
        onClick={onToggleShow}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-500"
      >
        {show ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}

/** The rules, each ticked once the password meets it. */
export function PolicyChecklist({
  passes,
  confirmMatches,
}: {
  readonly passes: boolean[];
  readonly confirmMatches: boolean;
}): JSX.Element {
  return (
    <ul className="text-xs space-y-1 mt-2">
      {PASSWORD_POLICY.map((rule, i) => (
        <li key={rule.label} style={{ color: passes[i] ? '#16A34A' : '#9CA3AF' }}>
          {passes[i] ? '✓' : '○'} {rule.label}
        </li>
      ))}
      <li style={{ color: confirmMatches ? '#16A34A' : '#9CA3AF' }}>
        {confirmMatches ? '✓' : '○'} Confirmation matches
      </li>
    </ul>
  );
}
